import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Core from '../components/core-view';
import {
  isUserInvitationPage,
  isInvitationAcceptancePage,
} from 'lib/utility-functions';

import {
  uiAlertAuthenticationWarningVisible,
  uiAlertAuthenticationExpiredVisible,
  uiToastrMessage,
  uiConfirmDialog,
  uiMessageBannerVisible,
} from 'modules/ui-module';

export const mapStateToProps = (state) => ({
  alertAuthWarningIsVisible: uiAlertAuthenticationWarningVisible(state),
  alertAuthExpiredIsVisible: uiAlertAuthenticationExpiredVisible(state),
  messageBannerVisible: uiMessageBannerVisible(state),
  toastrMessage: uiToastrMessage(state),
  confirmDialog: uiConfirmDialog(state),
});

export const CoreContainer = (props) => (
  <Core
    alertAuthWarningIsVisible={props.alertAuthWarningIsVisible}
    alertAuthExpiredIsVisible={props.alertAuthExpiredIsVisible}
    messageBannerVisible={props.messageBannerVisible}
    toastrMessage={props.toastrMessage}
    confirmDialog={props.confirmDialog}
    useStandardNav={!(isUserInvitationPage() || isInvitationAcceptancePage())}
  />
);

CoreContainer.propTypes = {
  alertAuthWarningIsVisible: PropTypes.bool,
  alertAuthExpiredIsVisible: PropTypes.bool,
  messageBannerVisible: PropTypes.bool,
  toastrMessage: PropTypes.shape({
    type: PropTypes.string,
    messageId: PropTypes.string,
    params: PropTypes.object,
  }),
  confirmDialog: PropTypes.shape({
    textResourceId: PropTypes.string,
    yesCallbackFn: PropTypes.func,
    noCallbackFn: PropTypes.func,
  }),
};

export default connect(mapStateToProps)(CoreContainer);
